/**
 * @generated SignedSource<<06d85713555b3e4c5e75ecb86af72ad2>>
 * @relayHash eb102bdaa211563303c83d89ef60bf26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 975b56d264a64cb33e0b46e61fcd7414a9f0d26c1024de322dde7ffe79ca736e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables = {
  cloudId: string;
  container: string;
  isAgentKbEnabled: boolean;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data = {
  readonly knowledgeBase: {
    readonly knowledgeBase: {
      readonly __typename: "KnowledgeBaseSources";
      readonly edge: ReadonlyArray<{
        readonly node: {
          readonly sourceType: string;
          readonly sourceVisibility?: string | null | undefined;
        };
      } | null | undefined>;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly knowledgeBase_getLinkedSourceTypes: {
    readonly linkedSourceTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined;
};
export type knowledgeHubBrowseAllArticlesKBTypeCheckerQuery = {
  response: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$data;
  variables: knowledgeHubBrowseAllArticlesKBTypeCheckerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "container"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isAgentKbEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "container",
    "variableName": "container"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "sourceType"
},
v5 = {
  "condition": "isAgentKbEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceVisibility"
    }
  ]
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "linkedSourceTypes"
    }
  ],
  "type": "KnowledgeBaseLinkedSourceTypes"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "KnowledgeBaseSourceEdge",
                      "kind": "LinkedField",
                      "name": "edge",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "KnowledgeBaseSource",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": (v4/*: any*/),
                              "action": "THROW",
                              "path": "knowledgeBase.knowledgeBase.edge.node.sourceType"
                            },
                            (v5/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "knowledgeBase.knowledgeBase.edge"
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "KnowledgeBaseQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeBase",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "knowledgeBase",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeBaseSourceEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "KnowledgeBaseSource",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeBaseSources"
              },
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "knowledgeBase_getLinkedSourceTypes",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "975b56d264a64cb33e0b46e61fcd7414a9f0d26c1024de322dde7ffe79ca736e",
    "metadata": {},
    "name": "knowledgeHubBrowseAllArticlesKBTypeCheckerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dc3e88c81c8f019e8d183c5b195482e6";

export default node;
